import { gql } from '@apollo/client';

export const GET_PARTNER_PENALTY_UPLOAD_TASKS = gql`
  query GetPartnerPenaltyUploadTasks {
    getPartnerPenaltyUploadTasks {
      id
      submitterName
      rowCount
      successCount
      failCount
      status
      failureReason
      sourceFileName
      resultFileS3Key
      resultFileName
      createdAt
      completedAt
      penaltyTypeLabels
    }
  }
`;

export const GET_PARTNER_PENALTY_RESULT_DOWNLOAD_URL = gql`
  query GetPartnerPenaltyResultDownloadUrl($taskId: Long!) {
    getPartnerPenaltyResultDownloadUrl(taskId: $taskId)
  }
`;

export const DOWNLOAD_PARTNER_PENALTY_UPLOAD_TEMPLATE = gql`
  query DownloadPartnerPenaltyUploadTemplate {
    downloadPartnerPenaltyUploadTemplate
  }
`;
